import React, { useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSiteSettings } from "src/context/SiteSettingsContext";

const AuthLayout = () => {
  const location = useLocation();
  const { site } = useSiteSettings();

  const BackgroundImage = useCallback(
    () => (
      <div className="fixed left-0 top-0 z-[-1] flex h-full w-full">
        {site?._id && (
          <div
            className="absolute left-0 top-0 z-[-1] h-full w-full bg-cover bg-center"
            style={{ backgroundImage: `url(${site?.background_logo}${site?.updated_at ? `?v=${site.updated_at}` : ""})` }}
          />
        )}
      </div>
    ),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [site?._id],
  );

  return (
    <div className="flex h-screen flex-col">
      {location.pathname !== "/" && <BackgroundImage />}
      <Outlet />
    </div>
  );
};

export default AuthLayout;
